/**
 * Activities Grid Block - Frontend Script
 * Handles category filtering for the activities grid
 */

document.addEventListener( 'DOMContentLoaded', function () {
	document.querySelectorAll( '.wp-block-theme-activities-grid' ).forEach( ( gridContainer ) => {
		const filterContainer = gridContainer.querySelector( '.activities-filter' );
		if ( ! filterContainer ) return;

		const gridElement  = gridContainer.querySelector( '.maze-activities-grid' );
		const activityCards = gridElement.querySelectorAll( '[data-activity-category]' );

		// Tous les boutons (y compris "all" rendu côté PHP)
		const filterButtons = filterContainer.querySelectorAll( '.activities-filter-btn' );

		filterButtons.forEach( ( button ) => {
			button.addEventListener( 'click', function () {
				const selectedCategory = this.getAttribute( 'data-category' );

				// Mise à jour de l'état actif
				filterButtons.forEach( ( btn ) => btn.classList.remove( 'is-active' ) );
				this.classList.add( 'is-active' );

				// Filtrage des cartes
				activityCards.forEach( ( card ) => {
					const cardCategory = card.getAttribute( 'data-activity-category' );
					const visible = selectedCategory === 'all' || cardCategory === selectedCategory;
					card.classList.toggle( 'hidden', ! visible );
				} );
			} );
		} );
	} );
} );
